import RecoverPassContainer from './RecoverPassContainer';

export default RecoverPassContainer;
